import { Box, Icon, Text } from '@chakra-ui/react';

import { isExternal } from '@/components/atoms/isExternal';
import { RouterLink } from '@/components/atoms/RouterLink';

import { type NavItemType } from './Sidebar.hooks';
import { navItemCss } from './Sidebar.styles';

type NavItemProps = {
  item: NavItemType;
  active?: boolean;
  onNavigate?: () => void;
};

const NavItemContent = ({ item }: { item: NavItemType }) => (
  <>
    <Icon className="nav-icon" as={item.icon} />
    <Box as="span" className="nav-text">
      <Text as="span" className="nav-label">
        {item.label}
      </Text>
      {item.description && (
        <Text as="span" className="nav-description">
          {item.description}
        </Text>
      )}
    </Box>
  </>
);

export const NavItem = ({ item, active, onNavigate }: NavItemProps) => {
  if (item.to && !item.disabled)
    return (
      <Box asChild css={navItemCss} className="NavItem">
        <RouterLink
          to={item.to}
          aria-current={active ? 'page' : undefined}
          onClick={onNavigate}
        >
          <NavItemContent item={item} />
        </RouterLink>
      </Box>
    );

  if (item.href && !item.disabled)
    return (
      <Box asChild css={navItemCss} className="NavItem">
        <a href={item.href} onClick={onNavigate} {...isExternal}>
          <NavItemContent item={item} />
        </a>
      </Box>
    );

  return (
    <Box css={navItemCss} className="NavItem" aria-disabled="true">
      <NavItemContent item={item} />
    </Box>
  );
};
